import React, { useState, useEffect, useCallback } from "react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../vendorProfile/profile.css";
import { useFormik } from "formik";
import { useUserAuth } from "../../context/UserAuthContext";
import { basicDetailsSchema } from "../schemas";
import CustomSelect from "../customSelect/CustomSelect";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Select from "react-select";

const BasicHome = () => {
  let navigate = useNavigate();
  const [edit, setEdit] = useState(true);
  const [loading, setLoading] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [currencies, setCurrencies] = useState([]);
  const { user, language, CityNameFinder, convertToLSlug, token } =
    useUserAuth();
  const merchant_id = user.uid;
  const base_url = import.meta.env.VITE_LOCAL_BASE_URL;
  const [merchant, setMerchant] = useState({});
  // console.log("merchant", merchant);
  const [country, setCountry] = useState([]);
  const [state, setState] = useState([]);
  const [city, setCity] = useState([]);
  const [locality, setLocality] = useState([]);
  // console.log("locality", locality);
  // console.log('cities merchant', merchant)
  const formik = useFormik({
    initialValues: {
      country_id: "",
      state_id: "",
      city_id: "",
      pincode: "",
      locality_id: "",
      street: "",
      landmark: "",
      mobno: "",
    },
    validationSchema: basicDetailsSchema,
  
    onSubmit: async (values) => {
      
      const {
        country_id,
        state_id,
        city_id,
        pincode,
        locality_id,
        street,
        landmark,
        mobno,
      } = values;
      const city_name = await CityNameFinder(city_id);
      const citySlug = convertToLSlug(city_name);
      const businessSlug = merchant?.slug;
      const finalSlug = `${businessSlug}-${citySlug}`;
      const data = {
        country_id,
        state_id,
        city_id,
        pincode,
        locality_id,
        street,
        landmark,
        mobno,
        slug: finalSlug,
        currencies_id: selectedCountry?.id || null,
      };
      try {
        setLoading(true);
        await axios.post(
          `${base_url}/api/v1/users/home/basic-details/${merchant_id}`,
          data,
        );
        toast.success("Profile Created Successfully");
        navigate("/dashboard/dash_board");
        try {
          await axios.post(
            `${base_url}/api/v1/email/welcome`,
            {
              business_name: merchant.business_name,
              email: merchant.email,
              password: merchant.password || "",
              country_id: country_id || "",
            },
            {
              headers: {
                "Content-Type": "application/json",
              },
            },
          );
        } catch (err) {
          console.error("Mail sending error:", err);
        }
      } catch (err) {
        console.log(err);
      } finally {
        setLoading(false);
      }
    },
  });

  // Fetch countries
  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const res = await axios.get(`${base_url}/api/v1/countries`);
        setCountry(res.data.data);
      } catch (error) {
        console.log(`Error fetching countries: ${error}`);
      }
    };
    fetchCountries();
  }, [base_url]);

  // Fetch states based on selected country
  const fetchStates = async (country_id) => {
    try {
      const res = await axios.get(
        `${base_url}/api/v1/states/country/${country_id}`,
      );
      setState(
        res.data.data.map((doc) => ({
          key: doc.id,
          value: doc.name,
          country_id: doc.country_id,
        })),
      );
    } catch (error) {
      console.log(`Error fetching states: ${error}`);
    }
  };

  // Fetch cities based on selected state
  const fetchCities = async (state_id) => {
    try {
      setCity([]);
      const res = await axios.get(
        `${base_url}/api/v1/cities/state/${state_id}`,
      );
      setCity(
        res.data.data.map((doc) => ({
          key: doc.id,
          value: doc.name,
          state_id: doc.state_id,
        })),
      );
    } catch (error) {
      console.log(`Error fetching cities: ${error}`);
    }
  };

  // Fetch localities based on selected city
  const fetchLocalities = async (city_id) => {
    try {
      setLocality([]);
      const res = await axios.get(
        `${base_url}/api/v1/localities/city/${city_id}`,
      );
      setLocality(
        res.data.data.map((doc) => ({
          key: doc.id,
          value: doc.name,
          city_id: doc.city_id,
        })),
      );
    } catch (error) {
      console.log(`Error fetching localities: ${error}`);
    }
  };

  // Fetch merchant details
  useEffect(() => {
    if (!merchant_id) return;
    const getSingleDocumentHandler = async () => {
      try {
        const res = await axios.get(
          `${base_url}/api/v1/users/id/${merchant_id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );
        setMerchant(res?.data?.data);
        formik.setValues(res?.data?.data);
      } catch (error) {
        console.log(`Error fetching merchant details: ${error}`);
      }
    };
    getSingleDocumentHandler();
  }, [merchant_id, base_url]);

  // Handle country change
  useEffect(() => {
    if (formik.values.country_id) {
      fetchStates(formik.values.country_id);
    }
  }, [formik.values.country_id]);

  // Handle state change
  useEffect(() => {
    if (formik.values.state_id) {
      fetchCities(formik.values.state_id);
    }
  }, [formik.values.state_id]);

  // Handle city change
  useEffect(() => {
    if (formik.values.city_id) {
      fetchLocalities(formik.values.city_id);
    }
  }, [formik.values.city_id]);

  const fetchCurrentCountry = useCallback(async () => {
    if (!location?.country) return;
    try {
      const countryName = location.country.trim();
      const res = await axios.get(
        `${base_url}/api/v1/currency/country_name/?country=${countryName}`,
      );
      if (res?.data?.data) {
        const countryData = res?.data?.data;
        console.log("this data get to ip address", countryData);
        setSelectedCountry({
          value: countryData.country_id,
          label: `${countryData.flag} ${countryData.code}`,
          code: countryData.code?.replace("+", ""),
          flag: countryData.flag,
          name: countryData.country_name,
        });
      }
    } catch (error) {
      console.error("Error fetching user country:", error);
    }
  }, [location?.country]);

  // Fetch all countries
  const fetchCurrency = useCallback(async () => {
    try {
      const res = await axios.get(`${base_url}/api/v1/currency/country`);
      const data = Array.isArray(res.data.data) ? res.data.data : [];
      setCurrencies(data);

      // Set default to India if no country selected
      if (!selectedCountry?.value) {
        const india = data.find((c) => c.country_name === "India");
        if (india) {
          setSelectedCountry({
            value: india.country_id,
            label: `${india.flag} ${india.code}`,
            code: india.code.replace("+", ""),
            flag: india.flag,
            name: india.country_name,
            id: india.id,
          });
        }
      }
    } catch (error) {
      console.error("Error fetching currencies:", error);
    }
  }, []);

useEffect(() => {
  fetchCurrency();
}, []);

useEffect(() => {
  if (location?.country) {
    fetchCurrentCountry();
  }
}, [location?.country]);

  const countryOptions = currencies.map((item) => ({
    value: item.country_id,
    label: `${item.flag} ${item.code}`,
    code: item.code.replace("+", ""),
    flag: item.flag,
    name: item.country_name,
    id: item.id,
  }));

  useEffect(() => {
    if (formik.values.country_id && currencies.length > 0) {
      const matchedCountry = currencies.find(
        (item) => item.country_id === formik.values.country_id,
      );
      if (matchedCountry) {
        setSelectedCountry({
          value: matchedCountry.country_id,
          label: `${matchedCountry.flag} ${matchedCountry.code}`,
          code: matchedCountry.code.replace("+", ""),
          flag: matchedCountry.flag,
          name: matchedCountry.country_name,
          id: matchedCountry.id,
        });
      }
    }
  }, [formik.values.country_id, currencies]);
  return (
    <div className="page-wrapper bg-white">
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <div className="card">
              <div
                className="card-header text-center text-white"
                style={{ backgroundColor: "#085f9a" }}
              >
                <h5>
                  {language === "en"
                    ? "Complete Your Basic Details"
                    : "अपने बिजनेस की जानकारी भरें"}
                </h5>
              </div>
              <div className="card-body">
                <form className="py-3" onSubmit={formik.handleSubmit}>
                  <div className="row">
                    <div className="form-group col-md-6 mb-3">
                      <label>
                        Country<span className="text-danger">*</span>
                      </label>
                      <select
                        value={formik.values.country_id}
                        name="country_id"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        className="form-select"
                      >
                        <option value="">Select Country</option>
                        {country?.map((item, index) => (
                          <option value={item.id} key={index}>
                            {item.name}
                          </option>
                        ))}
                      </select>
                      {formik.touched.country_id &&
                        formik.errors.country_id && (
                          <span className="error text-danger">
                            {formik.errors.country_id}
                          </span>
                        )}
                    </div>
                    <div className="form-group col-md-6 mb-3">
                      <CustomSelect
                        title="State/UT"
                        placeholder="Enter  State/UT"
                        name="state_id"
                        data={state}
                        defaultValue={formik.values.state_id}
                        onChange={(value) =>
                          formik.handleChange("state_id")(value)
                        }
                        error={
                          formik.touched.state_id && formik.errors.state_id
                        }
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="form-group col-md-6 mb-3">
                      <CustomSelect
                        title="City"
                        placeholder="Enter City"
                        name="city_id"
                        data={city}
                        defaultValue={formik.values.city_id}
                        onChange={(value) =>
                          formik.handleChange("city_id")(value)
                        }
                        error={formik.touched.city_id && formik.errors.city_id}
                      />
                    </div>

                    <div className="form-group col-md-6">
                      {/* <CustomSelect
                        title="Locality"
                        placeholder="Enter Locality"
                        name="locality_id"
                        data={locality}
                        defaultValue={formik.values.locality_id}
                        onChange={(value) =>
                          formik.handleChange("locality_id")(value)
                        }
                        isRequired={false}
                        // error={
                        //   formik.touched.locality_id &&
                        //   formik.errors.locality_id
                        // }
                      /> */}

                      {/* <CustomSelect
                        title={
                          formik.values.country_id === "4Dj1nUEkp4vFOh4HI0CL"
                            ? "Locality"
                            : "Locality (Optional)"
                        }

                        isRequired = {false}
                        placeholder="Enter Locality"
                        name="locality_id"
                        data={locality}
                        defaultValue={formik.values.locality_id}
                        onChange={(value) =>
                          formik.handleChange("locality_id")(value)
                        }
                        error={
                          formik.touched.locality_id &&
                          formik.errors.locality_id
                        }
                      /> */}
                      <CustomSelect
                        title={
                          formik.values.country_id === "4Dj1nUEkp4vFOh4HI0CL"
                            ? "Locality"
                            : "Locality"
                        }
                        isRequired={
                          formik.values.country_id === "4Dj1nUEkp4vFOh4HI0CL"
                        }
                        placeholder="Enter Locality"
                        name="locality_id"
                        data={locality}
                        defaultValue={formik.values.locality_id}
                        onChange={(value) =>
                          formik.handleChange("locality_id")(value)
                        }
                        error={
                          formik.touched.locality_id &&
                          formik.errors.locality_id
                        }
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="form-group col-md-6 mb-3">
                      <label>
                        Pincode<span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        name="pincode"
                        placeholder="Enter Pincode"
                        onChange={formik.handleChange}
                        value={formik.values.pincode}
                        className="form-control"
                      />
                      {formik.touched.pincode && formik.errors.pincode && (
                        <span className="error text-danger">
                          {formik.errors.pincode}
                        </span>
                      )}
                    </div>
                    <div className="form-group col-md-6 mb-3">
                      <label>
                        Plot No/Street/Area
                        <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        name="street"
                        placeholder="Plot No/Street/Area"
                        className="form-control"
                        onChange={formik.handleChange}
                        value={formik.values.street}
                      />
                      {formik.touched.street && formik.errors.street && (
                        <span className="error text-danger">
                          {formik.errors.street}
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="row">
                    <div className="form-group col-md-6 mb-3">
                      <label>Landmark (Optional)</label>
                      <input
                        type="text"
                        name="landmark"
                        placeholder="Enter Landmark"
                        onChange={formik.handleChange}
                        value={formik.values.landmark}
                        className="form-control"
                      />
                      {formik.touched.landmark && formik.errors.landmark && (
                        <span className="error text-danger">
                          {formik.errors.landmark}
                        </span>
                      )}
                    </div>
                    <div className="form-group col-md-6 mb-3">
                      <label>
                        Mobile Number <span className="text-danger">*</span>
                      </label>
                      <div className="basic-home-style">
                        {/* Country Select */}
                        <div className="basic-home-select">
                          <Select
                            options={countryOptions}
                            value={selectedCountry}
                            onChange={(country) => {
                              setSelectedCountry(country);
                              formik.setFieldValue("country_id", country.value);
                            }}
                            menuPosition="fixed"
                            isSearchable
                            placeholder="Search..."
                            styles={{
                              control: (provided) => ({
                                ...provided,
                                border: "none",
                                minHeight: "35px",
                                borderRadius: "0",
                                boxShadow: "none",
                              }),
                              valueContainer: (provided) => ({
                                ...provided,
                                padding: "0 8px",
                              }),
                              singleValue: (provided) => ({
                                ...provided,
                                display: "flex",
                                alignItems: "center",
                                gap: "6px",
                              }),
                              dropdownIndicator: (provided) => ({
                                ...provided,
                                padding: "0 8px",
                                color: "#64748b",
                              }),
                              indicatorSeparator: () => null,
                              menu: (provided) => ({
                                ...provided,
                                zIndex: 9999,
                              }),
                            }}
                            components={{
                              IndicatorSeparator: () => null,
                            }}
                          />
                        </div>

                        {/* Mobile Input */}
                        <input
                          type="tel"
                          name="mobno"
                          maxLength={12}
                          placeholder="Mobile Number"
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          value={formik.values.mobno}
                          style={{
                            width: "65%",
                            border: "none",
                            outline: "none",
                            padding: "12px 10px",
                            fontSize: "15px",
                          }}
                        />
                      </div>

                      {/* Validation Error */}
                      {formik.touched.mobno && formik.errors.mobno && (
                        <span className="error text-danger">
                          {formik.errors.mobno}
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="form-group text-center">
                    <button
                      type="submit"
                      className="btn text-white"
                      style={{ backgroundColor: "#085f9a" }}
                      // disabled={!edit}
                      disabled={loading}
                    >
                      {loading ? "Please wait..." : "Submit"}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BasicHome;